import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

async function support_types(params) {
  return await request({
    url: `${ENDPOINT.DOCUMENT_UTILS}/support-types`,
    method: "get",
    params,
  });
}

async function post_count(data) {
  return await request({
    url: `${ENDPOINT.DOCUMENT_UTILS}/count`,
    method: "post",
    data,
  });
}

export default {
  support_types,
  post_count,
};
